/* inselvolt VAT-Switcher — Storefront
 *
 * PRODUKTSEITE: Der Umschalter ist eine VORSCHAU, kein globaler Modus.
 * Er zeigt plastisch, was der Artikel mit 19 % Umsatzsteuer kostet, und erklaert den Weg:
 * Die tatsaechliche Wahl trifft der Kunde im Warenkorb, der Kaufabschluss laeuft
 * dann ueber die B2B-Kasse. Deshalb wird hier NICHTS gespeichert und nichts am
 * Warenkorb geaendert — nur die Anzeige umgeschaltet.
 *
 * VARIANTENWECHSEL (Befund MS, 06.09.2026 — drei Fehler aus einer Wurzel):
 * Dawn ersetzt bei jedem Variantenwechsel den INHALT von #price-<section> durch
 * frisch geholtes Markup (VariantSelects.renderProductInfo, global.js).
 *   (a) Der Hauptpreis blieb stehen: Die einmal gemerkten Preisfelder waren nach
 *       dem Ersetzen geloeste Knoten — wir schrieben ins Leere.
 *   (b) Die Skonto-Zeile zeigte den Preis der ZUVOR gewaehlten Variante: Sie
 *       liegt ausserhalb des ersetzten Bereichs, lief also weiter — gerechnet
 *       aus dem einmal gelesenen data-Attribut, das den Wechsel nicht mitmacht.
 *   (c) Die Wahl "19 %" ueberlebte den Wechsel nicht: Der Knopf blieb aktiv,
 *       der Preis sprang auf den 0-%-Preis zurueck.
 * Daraus die drei Regeln dieses Abschnitts:
 *   1. Preisfelder werden bei JEDEM Schreiben frisch gesucht, nie gemerkt.
 *   2. Der Preis kommt aus den Variantendaten (Dawn-Ereignis bzw. Varianten-JSON),
 *      nie aus einem einmal gelesenen Attribut.
 *   3. Die Wahl lebt im Modul und wird nach jedem Wechsel erneut angewendet.
 *
 * Bewusst weiterhin ohne MutationObserver: Ein Beobachter auf dem Preisbereich
 * loest sich beim eigenen Schreiben selbst aus (am 05.09.2026 eingefroren).
 * Stattdessen wird an den Meldungen von Dawn angesetzt und danach nachgezogen.
 *
 * Rundung identisch zum Server (b2bKasse.server.ts): Cent x 1,19, gerundet.
 */
(function () {
  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' €';
  }

  var TEXT_0 = 'Inkl. 0 % Umsatzsteuer nach § 12 Abs. 3 UStG für Betreiber von Photovoltaikanlagen. '
    + '<a href="/pages/informationen-zur-mehrwertsteuer-befreiung">Details</a>';
  var TEXT_19 = 'So kaufen Sie mit 19 % Umsatzsteuer: in den Warenkorb legen, dort den Steuersatz '
    + 'wählen und zur Kasse gehen. Sie erhalten eine Rechnung mit offen ausgewiesener '
    + 'Umsatzsteuer. <a href="/pages/informationen-zur-mehrwertsteuer-befreiung">Details</a>';

  /* --- PRODUKTSEITE: Zustand, der den Variantenwechsel ueberlebt --- */
  var SATZ = '0';           // '0' | '19' — die getroffene Vorschau-Wahl
  var preisCent = null;     // 0-%-Preis der GEWAEHLTEN Variante
  var vergleichCent = 0;    // Streichpreis der gewaehlten Variante, 0 = keiner

  function mal119(cent) { return Math.round(cent * 1.19); }

  function ivBox() { return document.querySelector('.iv-vat[data-iv-preis-0]'); }

  function skontoFaktor() {
    var f = window.inselvolt && window.inselvolt.skonto_factor;
    return typeof f === 'number' ? f : 0.99;
  }

  /* Schreibt Preis, Streichpreis, Skonto, Knopfzustand und Text — immer aus dem
   * aktuellen Zustand, immer in frisch gesuchte Felder. Mehrfaches Aufrufen ist
   * folgenlos; genau darauf beruht das Nachziehen nach einem Wechsel. */
  function schreiben() {
    var box = ivBox();
    if (!box || !preisCent) return;
    var betrag = SATZ === '19' ? mal119(preisCent) : preisCent;
    var bereich = box.closest('.product__info-container') || document;

    /* .price__regular zeigt den Normalfall, .price__sale den Angebotsfall —
     * beide bedienen, sonst bleibt bei einem Angebot der sichtbare Preis stehen. */
    bereich.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale')
      .forEach(function (el) {
        if (el.closest('.iv-vat')) return;
        el.textContent = euro(betrag);
      });
    /* Streichpreis mitskalieren, sonst laege er bei 19 % unter dem Verkaufspreis. */
    if (vergleichCent) {
      var vergleich = SATZ === '19' ? mal119(vergleichCent) : vergleichCent;
      bereich.querySelectorAll('.price__sale s.price-item--regular')
        .forEach(function (el) { el.textContent = euro(vergleich); });
    }

    /* Skonto-Zeile mitfuehren: Vorschau-Preis und Skonto duerfen nie
     * auseinanderlaufen. Zwei Bauweisen im Theme — Snippet price_skonto
     * ([data-skonto-price], INNERHALB des ersetzten Preisbereichs) und Block
     * skonto_price (#skontoPriceDisplay-<section.id>, ausserhalb davon). */
    var skontoCent = Math.round(betrag * skontoFaktor());
    var skonto = bereich.querySelectorAll('[data-skonto-price], [id^="skontoPriceDisplay"]');
    if (!skonto.length) {
      skonto = document.querySelectorAll('[data-skonto-price], [id^="skontoPriceDisplay"]');
    }
    skonto.forEach(function (el) { el.textContent = euro(skontoCent); });

    /* Ersparnis-Abzeichen der Skonto-Box (Mockup 13.09.2026): als Differenz
     * gerechnet, damit Preis minus Ersparnis auf den Cent den Endpreis ergibt. */
    var ersparnis = bereich.querySelectorAll('[data-skonto-ersparnis]');
    if (!ersparnis.length) ersparnis = document.querySelectorAll('[data-skonto-ersparnis]');
    ersparnis.forEach(function (el) { el.textContent = euro(betrag - skontoCent) + ' sparen'; });

    /* Die Attribute bleiben wahr: Sie sind die Notversorgung beim ersten Laden
     * und die erste Fundstelle bei jeder spaeteren Fehlersuche. */
    box.setAttribute('data-iv-preis-0', String(preisCent));
    box.setAttribute('data-iv-preis-19', String(mal119(preisCent)));

    box.querySelectorAll('[data-iv-satz]').forEach(function (b) {
      var an = b.getAttribute('data-iv-satz') === SATZ;
      b.classList.toggle('is-aktiv', an);
      b.setAttribute('aria-pressed', String(an));
    });
    var info = box.querySelector('[data-iv-info]');
    if (info) info.innerHTML = SATZ === '19' ? TEXT_19 : TEXT_0;
  }

  function varianteUebernehmen(v) {
    if (!v || typeof v.price !== 'number') return false;
    preisCent = v.price;
    vergleichCent = typeof v.compare_at_price === 'number' ? v.compare_at_price : 0;
    return true;
  }

  /* Die gewaehlte Variante steht im Formularfeld [name="id"], ihre Preisdaten im
   * Varianten-JSON des Auswahlelements. Das ist die Quelle, die auch dann noch
   * stimmt, wenn eine Meldung von Dawn ausbleibt. */
  function gewaehlteVariante() {
    var wahl = document.querySelector('variant-selects, variant-radios');
    var json = wahl && wahl.querySelector('[type="application/json"]');
    var feld = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!json || !feld) return null;
    var id = parseInt(feld.value, 10);
    var daten;
    try { daten = JSON.parse(json.textContent); } catch (e) { return null; }
    if (!daten || !daten.length) return null;
    for (var i = 0; i < daten.length; i++) {
      if (daten[i].id === id) return daten[i];
    }
    return null;
  }

  /* Nach einem Variantenwechsel schreiben mehrere Stellen nacheinander: Dawn
   * ersetzt den Preisbereich erst, wenn sein fetch zurueck ist, und das
   * Skonto-Skript des Blocks schreibt 150 ms nach der Auswahl. Deshalb wird
   * mehrfach nachgezogen — jeder Aufruf ist folgenlos, wenn nichts zu tun ist. */
  var nachlauf = [];
  function nachschreiben() { schreiben(); moqAnwenden(); }
  function nachziehen() {
    nachschreiben();
    nachlauf.forEach(clearTimeout);
    nachlauf = [60, 250, 600, 1200].map(function (ms) { return setTimeout(nachschreiben, ms); });
  }

  var wechselGebunden = false;
  function wechselBinden() {
    if (wechselGebunden) return;
    wechselGebunden = true;

    /* Dawn meldet den Wechsel zweimal: 'dawnVariantChanged' sofort (mit den
     * Variantendaten, aber VOR dem Ersetzen des Preisbereichs) und ueber pubsub
     * 'variant-change' danach. Dazu die Aenderung des Formularfeldes als dritte,
     * theme-unabhaengige Spur. Faellt eine Meldung nach einem Theme-Update weg,
     * tragen die anderen. */
    document.addEventListener('dawnVariantChanged', function (e) {
      if (!varianteUebernehmen(e && e.detail && e.detail.variant)) {
        varianteUebernehmen(gewaehlteVariante());
      }
      nachziehen();
    });
    document.addEventListener('change', function (e) {
      var ziel = e.target;
      if (!ziel || !ziel.matches || !ziel.matches('input[name="id"]')) return;
      varianteUebernehmen(gewaehlteVariante());
      nachziehen();
    });
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (e) {
        if (!varianteUebernehmen(e && e.data && e.data.variant)) {
          varianteUebernehmen(gewaehlteVariante());
        }
        nachziehen();
      });
    }
  }

  function produktseite() {
    var box = ivBox();
    if (!box) return;
    var knoepfe = box.querySelectorAll('[data-iv-satz]');
    if (!knoepfe.length) return;  // Pflicht-19-Artikel: es gibt nichts umzuschalten

    /* Ab hier fuehrt iv-vat.js die Skonto-Zeile allein. Das Skript des Blocks
     * skonto_price rechnet immer mit 0 % und wuerde die 19-%-Vorschau 150 ms
     * spaeter ueberschreiben; es tritt anhand dieser Marke zurueck
     * (sections/main-product.liquid). */
    window.inselvolt = window.inselvolt || {};
    window.inselvolt.vatSkonto = true;

    if (!box.dataset.ivBereit) {
      box.dataset.ivBereit = '1';
      knoepfe.forEach(function (b) {
        b.addEventListener('click', function () {
          SATZ = b.getAttribute('data-iv-satz');
          schreiben();
        });
      });
      wechselBinden();
    }

    if (!varianteUebernehmen(gewaehlteVariante())) {
      preisCent = parseInt(box.getAttribute('data-iv-preis-0'), 10) || null;
      vergleichCent = parseInt(box.getAttribute('data-iv-vergleich-0'), 10) || 0;
    }
    /* Bei 0 % steht das serverseitig gerenderte Markup schon richtig — dann
     * wird nichts angefasst. Geschrieben wird nur, wenn die Vorschau abweicht
     * (etwa nach shopify:section:load bei aktiver 19-%-Wahl). */
    if (SATZ !== '0') schreiben();
  }

  /* --- WARENKORB: hier faellt die verbindliche Entscheidung --- */
  var PROXY = '/apps/vat/api/b2b-checkout';
  var ERKLAERUNG_VERSION = 'v1';

  function attributSetzen(satz, grund, vorbelegt) {
    /* `grund` unterscheidet zwei Wege zum SELBEN Satz: der deutsche
     * Nicht-Betreiber und die Ausfuhr in die Schweiz zahlen beide 19 %, aber
     * nur der erste gibt dabei eine Erklaerung nach UStAE 12.18 ab. Der Merker
     * traegt die Unterscheidung bis in den Auftrag — daran haengt spaeter die
     * Fristueberwachung der Erstattung. */
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          iv_steuersatz: satz,
          iv_grund: grund || '',
          /* Eine VORBELEGTE Erklaerung ist als solche erkennbar (19.09.2026).
           * Die Vorauswahl war eine Ansage; der Einwand dazu steht in
           * `entscheidung_vorauswahl-0-prozent_2026-09-19.md`. Wenn schon
           * vorbelegt wird, dann soll man den angeklickten Fall spaeter vom
           * durchgelaufenen unterscheiden koennen — ohne diesen Zusatz sehen
           * beide im Auftrag gleich aus, und genau das waere die Schwaeche,
           * vor der A2 gewarnt hat. */
          iv_erklaerung_betreiber: satz === '0'
            ? ERKLAERUNG_VERSION + '|' + new Date().toISOString() + (vorbelegt ? '|vorbelegt' : '')
            : ''
        }
      })
    }).catch(function () { /* die Kasse entscheidet ohnehin serverseitig neu */ });
  }

  function fehlerZeigen(text) {
    var f = document.getElementById('iv-vat-fehler');
    if (!f) return;
    if (text) f.textContent = text;
    f.removeAttribute('hidden');
    f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  async function b2bCheckout(button, lieferung) {
    var alt = button.textContent;
    button.disabled = true;
    button.textContent = 'Einen Moment — wir stellen auf 19 % Umsatzsteuer um …';
    try {
      var cart = await (await fetch('/cart.js')).json();
      var positionen = cart.items.map(function (i) {
        return { variantId: i.variant_id, menge: i.quantity };
      });
      /* Die Berater-Merkmale reisen mit: Die B2B-Kasse baut die Draft Order
       * nur aus den Positionen — ohne diese Zeilen ginge am 19-%-Weg verloren,
       * dass die Bestellung aus dem Kompatibilitätsberater kam (Befund
       * 19.10.2026: deshalb trug keine einzige B2B-Bestellung das Merkmal).
       * Ob sie an der Draft Order landen, entscheidet die Kasse serverseitig;
       * eine Kasse, die das Feld nicht kennt, ignoriert es folgenlos. */
      var attribute = {};
      Object.keys(cart.attributes || {}).forEach(function (k) {
        if (k.indexOf('iv_berater') === 0) attribute[k] = cart.attributes[k];
      });
      var d = await (await fetch(PROXY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ positionen: positionen, lieferung: lieferung, attribute: attribute })
      })).json();
      if (d && d.checkoutUrl) { window.location.href = d.checkoutUrl; return; }
      throw new Error((d && d.fehler) || 'unbekannt');
    } catch (e) {
      button.disabled = false;
      button.textContent = alt;
      /* Die Kasse prueft die Abholwahl selbst nach; ihr Grund steht dann hier,
       * sonst wuesste der Kunde nicht, was er aendern soll. */
      var grund = e && e.message && e.message !== 'unbekannt' ? ' ' + e.message : '';
      fehlerZeigen('Die Umstellung auf 19 % Umsatzsteuer hat leider nicht geklappt.' + grund
        + ' Bitte versuchen Sie es erneut oder schreiben Sie uns an support@inselvolt.de — '
        + 'wir stellen Ihnen die Bestellung mit ausgewiesener Umsatzsteuer direkt aus.');
    }
  }


  /* --- Express-Zahlknöpfe (PayPal, Shop Pay, Google/Apple Pay) ---
   * Sie führen direkt zur Zahlung und umgehen dabei die Steuersatzwahl. Zwei Folgen:
   * bei 19 % würde der 0-%-Preis berechnet, und selbst bei 0 % entstünde keine
   * dokumentierte Erklärung nach § 12 Abs. 3 UStG. Deshalb:
   *   keine Wahl  -> gesperrt, mit Hinweis
   *   0 %         -> frei (Erklärung liegt vor, Preis stimmt)
   *   19 %        -> ausgeblendet; bezahlt wird per PayPal im Kassen-Checkout,
   *                  den die B2B-Kasse öffnet (dort gibt es einen eigenen
   *                  PayPal-Express-Knopf, geprüft 05.09.2026)
   *
   * Seit dem 03.11.2026 zeichnet der Warenkorb keine Express-Knöpfe mehr
   * (main-cart-footer.liquid). Die Regeln bleiben für den Fall, dass eine App
   * oder Einstellung wieder einen einsetzt; ohne Knopf bleibt der Hinweis zu —
   * er versprach „direkt mit PayPal bezahlen", und das gäbe es dann nicht.
   */
  function expressKnoepfe() {
    var box = document.getElementById('iv-vat-switcher');
    if (!box) return [];
    var treffer = [];
    document.querySelectorAll(
      '.cart__dynamic-checkout-buttons, .additional-checkout-buttons,'
      + ' [data-shopify="dynamic-checkout-cart"], shopify-accelerated-checkout,'
      + ' shopify-accelerated-checkout-cart'
    ).forEach(function (el) { if (treffer.indexOf(el) < 0) treffer.push(el); });
    return treffer;
  }

  function expressStand(satz) {
    var knoepfe = expressKnoepfe();
    var hinweis = document.getElementById('iv-vat-express-hinweis');
    var frei = satz === '0';

    /* Nie ausgrauen — entweder da oder weg (Vorgabe MS, 06.09.2026). Ein halb
     * bedienbarer Zahlknopf sieht nach Fehler aus und laedt zum Klicken ein. */
    knoepfe.forEach(function (el) {
      el.style.opacity = '';
      el.style.pointerEvents = '';
      if (frei) {
        el.style.display = '';
        el.removeAttribute('aria-hidden');
      } else {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });

    if (!hinweis) return;
    if (frei || !knoepfe.length) { hinweis.setAttribute('hidden', ''); return; }
    if (satz === '19') {
      hinweis.textContent = 'Mit 19 % Umsatzsteuer bezahlen Sie über »Auschecken« — '
        + 'dort stehen PayPal und alle weiteren Zahlarten zur Verfügung.';
    } else if (satz === 'pflicht') {
      hinweis.textContent = 'Bezahlen Sie über »Auschecken« — dort stehen PayPal und '
        + 'alle weiteren Zahlarten zur Verfügung.';
    } else {
      hinweis.textContent = 'Bitte wählen Sie zuerst den Steuersatz. Danach können Sie '
        + 'direkt mit PayPal bezahlen.';
    }
    hinweis.removeAttribute('hidden');
  }

  /* --- Lieferwahl (nur bei 19 %, dort Pflicht) ---
   * Befund 14.09.2026, Auftrag 56387: Die B2B-Kasse legt PV-Artikel als
   * Custom-Position an, und die hat an keinem Standort Bestand. Deren Checkout
   * kann Abholorte deshalb nicht nach Bestand filtern. Er bot „Lager Tübingen"
   * an, obwohl der Artikel nur in Altbach lag.
   *
   * Am 14.09. stand hier nur ein Hinweis. Am 15.09.2026 gemessen: Der Checkout
   * laesst sich NUR sperren, wenn die Draft Order eine feste Lieferzeile traegt
   * (messung_abholvorauswahl_2026-09-15.md). Deshalb faellt die Wahl jetzt hier:
   * Versand, oder Abholung an einem Ort, an dem JEDE Position verfuegbar ist.
   * Ohne Wahl kein Checkout. Die Kasse prueft den Ort serverseitig nach —
   * diese Liste ist Bedienung, keine Sicherung.
   *
   * Quelle ist der Abschnitt `iv-abholorte` je Variante: dieselben Bestaende,
   * nach denen der gewoehnliche Checkout filtert. Shopifys `available` sagt
   * nur, ob Bestand da ist, nicht ob er fuer die Menge reicht.
   *
   * Scheitert eine Abfrage, bleibt nur Versand waehlbar — mit dem Hinweis,
   * dass die Abholorte nicht geprueft werden konnten. Ein falsches „keine
   * Abholung moeglich" waere schlimmer, ein offener Checkout auch. */
  var lieferLauf = 0;

  /* Eine Wahl, die nur eine Moeglichkeit hat, ist keine Wahl (Vorgabe MS,
   * 18.09.2026): Gibt es zu dieser Bestellung keinen Abholort, an dem jede
   * Position vorraetig ist, bleibt Versand allein uebrig — dann steht er
   * vorausgewaehlt da, statt den Kunden einen Klick machen zu lassen, der
   * nichts entscheidet.
   *
   * Vorausgewaehlt wird NUR bei genau einer Moeglichkeit. Sobald es zwei gibt,
   * muss der Kunde sich aeussern: Die feste Lieferzeile bestimmt, wohin die
   * Ware geht, und die darf nicht aus einer Voreinstellung entstehen.
   * Eine frueher getroffene Wahl hat immer Vorrang. */
  function vorauswahlNoetig(anzahlMoeglichkeiten, schonGewaehlt) {
    return anzahlMoeglichkeiten === 1 && !schonGewaehlt;
  }

  function abholorte(variantId) {
    var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(wurzel + 'variants/' + variantId + '/?section_id=iv-abholorte')
      .then(function (a) {
        if (!a.ok) throw new Error('HTTP ' + a.status);
        return a.text();
      })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-iv-abholorte]');
        if (!el) throw new Error('Abschnitt iv-abholorte fehlt im Theme');
        return JSON.parse(el.textContent);
      });
  }

  /* Die Orte, an denen JEDE Position verfuegbar ist — dieselbe Regel wie
   * `gemeinsameAbholorte` in der Kasse. */
  function gemeinsameAbholorte(listen) {
    if (!listen.length) return [];
    return listen[0].filter(function (o) {
      return o.verfuegbar && listen.every(function (l) {
        return l.some(function (x) { return x.ort === o.ort && x.verfuegbar; });
      });
    });
  }

  function lieferHinweisText(orte, fehler) {
    if (fehler) {
      return 'Die Abholorte konnten gerade nicht geprüft werden — möglich ist Versand. '
        + 'Wenn Sie abholen möchten, laden Sie die Seite bitte neu.';
    }
    if (!orte.length) {
      return 'Für diese Bestellung gibt es keinen Abholort, an dem alle Artikel vorrätig '
        + 'sind — möglich ist Versand.';
    }
    return 'Abholung nur dort, wo Ihre ganze Bestellung vorrätig ist. Die Wahl gilt an der '
      + 'Kasse fest.';
  }

  function lieferwahlLesen() {
    var r = document.querySelector('[data-iv-lieferung]:checked');
    if (!r) return null;
    if (r.value === 'versand') return { art: 'versand' };
    return { art: 'abholung', ort: r.getAttribute('data-iv-ort') };
  }

  function lieferOption(wert, ort, kopf, zusatz) {
    var label = document.createElement('label');
    label.className = 'iv-vat-lieferung__option';
    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'iv_lieferung';
    input.value = wert;
    input.setAttribute('data-iv-lieferung', '');
    if (ort) input.setAttribute('data-iv-ort', ort);
    var text = document.createElement('span');
    var strong = document.createElement('strong');
    strong.textContent = kopf;
    text.appendChild(strong);
    if (zusatz) {
      var z = document.createElement('span');
      z.className = 'iv-vat-lieferung__zusatz';
      z.textContent = zusatz;
      text.appendChild(z);
    }
    label.appendChild(input);
    label.appendChild(text);
    return label;
  }

  function lieferungMarkieren() {
    document.querySelectorAll('.iv-vat-lieferung__option').forEach(function (l) {
      var r = l.querySelector('[data-iv-lieferung]');
      l.classList.toggle('is-gewaehlt', !!(r && r.checked));
    });
  }

  async function lieferwahl(satz) {
    var block = document.getElementById('iv-vat-lieferung');
    var optionen = document.getElementById('iv-vat-lieferung-optionen');
    var hinweis = document.getElementById('iv-vat-lieferung-hinweis');
    if (!block || !optionen || !hinweis) return;
    var lauf = ++lieferLauf;
    if (satz !== '19') { block.setAttribute('hidden', ''); return; }

    var vorher = lieferwahlLesen(); // bleibt erhalten, wenn sie noch gilt
    optionen.textContent = '';
    hinweis.textContent = 'Abholorte werden geprüft …';
    block.removeAttribute('hidden');

    var orte = [];
    var fehler = null;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var ids = [];
      cart.items.forEach(function (i) { if (ids.indexOf(i.variant_id) < 0) ids.push(i.variant_id); });
      var listen = await Promise.all(ids.map(abholorte));
      if (lauf !== lieferLauf) return; // inzwischen neu gewaehlt oder Warenkorb geaendert
      orte = ids.length ? gemeinsameAbholorte(listen) : [];
    } catch (e) {
      if (lauf !== lieferLauf) return;
      fehler = e;
      if (window.console) console.warn('inselvolt Lieferwahl:', e);
    }

    optionen.appendChild(lieferOption('versand', null, 'Versand',
      'Versandkosten nach Gewicht — der Betrag steht an der Kasse'));
    orte.forEach(function (o) {
      optionen.appendChild(lieferOption('abholung', o.ort, 'Abholung in ' + o.ort,
        (o.adresse ? o.adresse + ' · ' : '') + 'kostenlos'));
    });
    hinweis.textContent = lieferHinweisText(orte, fehler);

    if (vorher) {
      var alt = optionen.querySelector(vorher.art === 'versand'
        ? '[data-iv-lieferung][value="versand"]'
        : '[data-iv-lieferung][data-iv-ort="' + String(vorher.ort).replace(/"/g, '') + '"]');
      if (alt) alt.checked = true;
    }

    var moeglichkeiten = optionen.querySelectorAll('[data-iv-lieferung]');
    if (vorauswahlNoetig(moeglichkeiten.length, !!optionen.querySelector('[data-iv-lieferung]:checked'))) {
      moeglichkeiten[0].checked = true;
    }
    optionen.querySelectorAll('[data-iv-lieferung]').forEach(function (r) {
      r.addEventListener('change', function () {
        lieferungMarkieren();
        var f = document.getElementById('iv-vat-fehler');
        if (f) f.setAttribute('hidden', '');
      });
    });
    lieferungMarkieren();
  }

  /* Zwischensumme zum gewaehlten Satz (28.09.2026). Hier wird NUR das Merkmal
   * am Footer gesetzt, nie ein Betrag: Die Betraege schreibt Liquid, und Dawn
   * ersetzt sie bei jeder Mengenaenderung (`.js-contents`). Der Footer selbst
   * bleibt stehen, wird aber trotzdem jedes Mal frisch gesucht (Lehre 22). */
  function summeZeigen(satz) {
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.setAttribute('data-iv-satz', satz === '19' ? '19' : '0');
  }

  /* Betraege im Schalter nach einer Mengenaenderung (28.09.2026).
   *
   * Befund: Die Karten „0 %" und „19 %" zeigten nach einer Mengenaenderung
   * weiter die alten Summen, waehrend die Zwischensumme darunter schon die
   * neue trug — Dawn zeichnet nur `.js-contents` neu, der Schalter bleibt
   * stehen. Den ganzen Schalter zu ersetzen hiesse, Wahl, Lieferwahl und
   * Knopf-Bindungen zu verlieren.
   *
   * Deshalb: den Footer frisch vom Server holen und nur die Betraege
   * uebernehmen. Die Zahlen schreibt weiter allein Liquid; hier werden sie
   * nur getragen, nie gerechnet. Hat sich der AUFBAU geaendert (nur noch
   * Pflicht-19-Artikel, gemischter Warenkorb, leer), passt kein Betrag mehr
   * an seinen Platz — dann wird die Seite neu geladen. */
  var betragLauf = 0;
  function schalterAufbau(box) {
    return [
      box.getAttribute('data-iv-pflicht'),
      box.getAttribute('data-iv-gemischt'),
      box.querySelectorAll('.iv-vat-switcher__preis').length
    ].join('|');
  }
  function betraegeNachziehen() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !footer.dataset.id) return;
    var lauf = ++betragLauf;
    return fetch('/cart?section_id=' + encodeURIComponent(footer.dataset.id))
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (lauf !== betragLauf) return; // inzwischen erneut geaendert
        var neu = new DOMParser().parseFromString(html, 'text/html').getElementById('iv-vat-switcher');
        var box = document.getElementById('iv-vat-switcher');
        if (!box) return;
        if (!neu || schalterAufbau(neu) !== schalterAufbau(box)) { window.location.reload(); return; }
        var quelle = neu.querySelectorAll('.iv-vat-switcher__preis');
        box.querySelectorAll('.iv-vat-switcher__preis').forEach(function (el, i) {
          el.textContent = quelle[i].textContent;
        });
        ['data-summe-0', 'data-summe-19'].forEach(function (a) {
          box.setAttribute(a, neu.getAttribute(a) || '');
        });
      })
      .catch(function (e) {
        /* Lieber neu laden als falsche Betraege stehen lassen. */
        console.warn('iv-vat: Betraege nicht nachgezogen', e);
        if (lauf === betragLauf) window.location.reload();
      });
  }

  function warenkorb() {
    var box = document.getElementById('iv-vat-switcher');
    if (!box || box.dataset.ivBereit) return;
    box.dataset.ivBereit = '1';

    /* Warenkorb nur mit Pflicht-19-Artikeln: Es gibt nichts zu waehlen. */
    var pflicht = box.getAttribute('data-iv-pflicht') === '1';
    var gewaehltJetzt = box.querySelector('[data-iv-radio]:checked');

    /* Die Vorauswahl muss ins Merkmal, nicht nur in den Knopf.
     *
     * Der Kassen-Waechter kennt nur den GESPEICHERTEN Satz (`wahlBekannt` aus
     * `/cart.js`). Ein angekreuzter Knopf ohne Merkmal haette den Kunden beim
     * Druck auf „Auschecken" zurueck in den Warenkorb geworfen — sichtbar
     * nichts gewaehlt, und doch kommt er nicht weiter. Deshalb wird hier
     * einmal geschrieben, und `wahlBekannt` gleich mitgesetzt, damit der
     * Waechter nicht auf die Antwort warten muss. */
    if (!pflicht && gewaehltJetzt && box.getAttribute('data-iv-vorbelegt') === '1') {
      attributSetzen(gewaehltJetzt.value, gewaehltJetzt.getAttribute('data-iv-grund'), true);
      wahlBekannt = gewaehltJetzt.value;
    }
    expressStand(pflicht ? 'pflicht' : (gewaehltJetzt ? gewaehltJetzt.value : null));
    lieferwahl(gewaehltJetzt ? gewaehltJetzt.value : null);
    if (!pflicht && gewaehltJetzt) summeZeigen(gewaehltJetzt.value);

    /* Dawn rendert bei Mengenaenderungen nur Teile des Footers neu, der
     * Schalter bleibt stehen. Seine Positionen koennen sich aber geaendert haben. */
    if (typeof subscribe === 'function') {
      subscribe('cart-update', function () {
        var g = document.querySelector('[data-iv-radio]:checked');
        lieferwahl(g ? g.value : null);
        betraegeNachziehen();
      });
    }

    function markieren() {
      box.querySelectorAll('.iv-vat-switcher__option').forEach(function (l) {
        var r = l.querySelector('[data-iv-radio]');
        l.classList.toggle('is-gewaehlt', !!(r && r.checked));
      });
      var a = document.getElementById('iv-vat-aendern');
      if (a) {
        if (box.querySelector('[data-iv-radio]:checked')) a.removeAttribute('hidden');
        else a.setAttribute('hidden', '');
      }
    }
    markieren();

    box.querySelectorAll('[data-iv-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        attributSetzen(r.value, r.getAttribute('data-iv-grund'));
        wahlBekannt = r.value;
        expressStand(r.value);
        lieferwahl(r.value);
        summeZeigen(r.value);
        markieren();
        var f = document.getElementById('iv-vat-fehler');
        if (f) f.setAttribute('hidden', '');
      });
    });

    document.querySelectorAll('#checkout, [name="checkout"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        /* Erst die Mindestmengen — sie gelten auch im Warenkorb ohne Steuerwahl
         * (Pflicht-19-Artikel). Ist der Stand unbekannt (Abruf gescheitert),
         * ergibt `moqVerstoesse` eine leere Liste und der Klick geht durch:
         * Einen zahlenden Kunden wegen unseres eigenen Ladefehlers aufzuhalten
         * kostet mehr als eine Bestellung unter Mindestmenge, die wir sehen. */
        var moqOffen = moqVerstoesse(moqStand);
        if (moqOffen.length) {
          e.preventDefault(); e.stopPropagation();
          fehlerZeigen(moqMeldung(moqOffen));
          return;
        }
        if (!document.querySelectorAll('[data-iv-radio]').length) return;
        var gewaehlt = document.querySelector('[data-iv-radio]:checked');
        if (!gewaehlt) {
          e.preventDefault(); e.stopPropagation();
          fehlerZeigen('Bitte wählen Sie zuerst den Steuersatz.');
          return;
        }
        if (gewaehlt.value === '19') {
          e.preventDefault(); e.stopPropagation();
          var lieferung = lieferwahlLesen();
          if (!lieferung) {
            fehlerZeigen('Bitte wählen Sie Versand oder einen Abholort.');
            return;
          }
          b2bCheckout(btn, lieferung);
        }
      }, true);
    });
  }

  /* --- MINDESTBESTELLMENGE (MOQ) -------------------------------------
   * Quelle ist das Varianten-Metafeld `custom.moq`. Es gilt an drei Stellen,
   * und alle drei lesen denselben Text und dieselbe Regel aus diesem Abschnitt:
   *   Produktseite  — Untergrenze am Mengenfeld, ueber den Variantenwechsel hinweg,
   *   Warenkorb     — Untergrenze am Mengenfeld, Kasse gesperrt bei Unterschreitung,
   *   Kassen-Waechter — auch aus der Schublade von UpCart heraus.
   *
   * Befund MS, 18.09.2026: Die Mengenpruefung stand nur auf der Produktseite
   * (main-product.liquid). Wer den Artikel in den Warenkorb legte und die Menge
   * dort reduzierte, bestellte unter der Mindestmenge.
   *
   * Die Liste des Warenkorbs kommt aus dem Abschnitt `iv-moq` — `/cart.js`
   * liefert keine Metafelder. Scheitert der Abruf, wird zum Warenkorb geleitet
   * statt durchgelassen: die sichere Richtung, wie bei der Steuersatzwahl.
   *
   * Bewusst ohne Selbstkorrektur der Menge: Eine Bestellung stillschweigend zu
   * verzehnfachen ist teurer als ein Hinweis. Der Kunde aendert selbst. */
  var MOQ_SPEICHER = 'ivMoqMeldung'; // ueberlebt die Umleitung auf /cart

  function moqText(moq, titel) {
    return titel
      ? 'Bei „' + titel + '“ gilt eine Mindestbestellmenge von ' + moq + '.'
      : 'Bei diesem Artikel gilt eine Mindestbestellmenge von ' + moq + '.';
  }

  /* Eine Zeile ist verletzt, wenn sie unter ihrer eigenen Mindestmenge liegt.
   * `moq <= 1` ist keine Mindestmenge, sondern der Normalfall. */
  function moqVerstoesse(liste) {
    return (liste || []).filter(function (z) {
      var moq = parseInt(z && z.moq, 10) || 1;
      var menge = parseInt(z && z.menge, 10) || 0;
      return moq > 1 && menge < moq;
    });
  }

  /* Ein Artikel: der Satz ohne Namen — der Kunde sieht ja, welcher gemeint ist.
   * Mehrere: jeder mit Namen, sonst weiss er nicht, welche Zeile er anfassen soll. */
  function moqMeldung(verstoesse) {
    if (!verstoesse.length) return '';
    if (verstoesse.length === 1) return moqText(verstoesse[0].moq, null);
    return verstoesse.map(function (z) { return moqText(z.moq, z.titel); }).join(' ');
  }

  function moqWarenkorbListe() {
    var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(wurzel + '?section_id=iv-moq')
      .then(function (a) {
        if (!a.ok) throw new Error('HTTP ' + a.status);
        return a.text();
      })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-iv-moq]');
        if (!el) throw new Error('Abschnitt iv-moq fehlt im Theme');
        return JSON.parse(el.textContent);
      });
  }

  /* --- Produktseite --- */
  function moqKarte() {
    var el = document.querySelector('[data-iv-moq-varianten]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function moqDerWahl() {
    var karte = moqKarte();
    if (!karte) return 1;
    var feld = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var moq = feld && karte[String(feld.value)];
    return parseInt(moq, 10) || 1;
  }

  /* Wird nach jedem Variantenwechsel mehrfach aufgerufen (siehe `nachziehen`);
   * jeder Aufruf ist folgenlos, wenn sich nichts geaendert hat. Genau deshalb
   * steht hier kein setTimeout und kein Beobachter. */
  /* Dawn haengt das Mengenfeld ueber `form="<id>"` an das Kaufformular — es
   * steht NICHT darin. Am 18.09.2026 an der laufenden Ladenfront gemessen:
   * `form[action*="/cart/add"] input[name="quantity"]` trifft nichts, waehrend
   * dasselbe Muster fuer `input[name="id"]` stimmt (das Feld liegt im
   * Formular). Deshalb der Infobereich zuerst. */
  function moqMengenfeld() {
    return document.querySelector('.product__info-container input[name="quantity"]')
      || document.querySelector('form[action*="/cart/add"] input[name="quantity"]')
      || document.querySelector('input[name="quantity"]');
  }

  function moqAnwenden() {
    var feld = moqMengenfeld();
    if (!feld) return;
    var moq = moqDerWahl();
    var hinweis = document.querySelector('[data-iv-moq-hinweis]');

    if (String(feld.getAttribute('min')) !== String(moq)) {
      feld.setAttribute('min', String(moq));
      feld.setAttribute('data-min', String(moq));
      /* Der Wert wird nur angehoben, nie gesenkt: Wer 20 Module will, behaelt 20. */
      if ((parseInt(feld.value, 10) || 0) < moq) feld.value = String(moq);
    }
    if (hinweis) {
      hinweis.textContent = moq > 1 ? moqText(moq, null) : '';
      if (moq > 1) hinweis.removeAttribute('hidden'); else hinweis.setAttribute('hidden', '');
    }
  }

  function moqProduktseite() {
    var feld = moqMengenfeld();
    if (!feld || !moqKarte()) return;
    moqAnwenden();
    wechselBinden(); // dieselben drei Spuren wie die Preisvorschau
    if (feld.dataset.ivMoq) return;
    feld.dataset.ivMoq = '1';
    feld.addEventListener('change', function () {
      var moq = moqDerWahl();
      if ((parseInt(feld.value, 10) || 0) < moq) {
        feld.value = String(moq);
        var hinweis = document.querySelector('[data-iv-moq-hinweis]');
        if (hinweis) {
          hinweis.classList.add('iv-moq--laut');
          setTimeout(function () { hinweis.classList.remove('iv-moq--laut'); }, 1500);
        }
      }
    });
  }

  /* --- Warenkorbseite --- */
  var moqStand = null; // Liste des Warenkorbs, null = noch unbekannt

  function moqWarenkorbPruefen() {
    return moqWarenkorbListe().then(function (liste) {
      moqStand = liste;
      return moqVerstoesse(liste);
    });
  }

  function moqWarenkorb() {
    if (!document.getElementById('iv-vat-switcher')) return; // nur die Warenkorbseite
    var gemerkt = null;
    try { gemerkt = sessionStorage.getItem(MOQ_SPEICHER); } catch (e) { /* egal */ }
    if (gemerkt) {
      try { sessionStorage.removeItem(MOQ_SPEICHER); } catch (e) { /* egal */ }
      fehlerZeigen(gemerkt);
    }
    moqWarenkorbPruefen().catch(function () { moqStand = null; });
    if (typeof subscribe === 'function') {
      subscribe('cart-update', function () {
        moqWarenkorbPruefen().catch(function () { moqStand = null; });
      });
    }
  }

  /* --- Kassen-Waechter: kein Weg an der Steuersatzwahl vorbei ---
   * Befund 06.09.2026: Die App UpCart (App-Extension upcart-2) blendet nach
   * "In den Warenkorb legen" eine eigene Schublade ein. Ihr Knopf "Zur Kasse"
   * liegt in einem Shadow DOM und traegt eine direkte Kassen-Adresse
   * (/cart/c/<token>). Er uebersprang damit die Warenkorbseite — und dort faellt
   * die Steuersatzwahl und entsteht die Betreiber-Erklaerung. Ein Kunde konnte so
   * 19 % nie waehlen, und selbst der 0-%-Kauf lief ohne dokumentierte Erklaerung.
   *
   * Regel: Ausserhalb der Warenkorbseite fuehrt jeder Kassen-Klick zuerst auf
   * /cart. Ausnahme: Die Wahl "0 %" liegt bereits als Warenkorb-Merkmal vor —
   * dann ist alles erklaert und der Preis stimmt, der Klick geht durch.
   *
   * Der Waechter greift bewusst app-unabhaengig (Adresse statt Knopf-Identitaet),
   * damit er auch nach einem Update von UpCart oder bei einer anderen Schublade
   * haelt. Steht die Wahl noch nicht fest (Ladefehler), wird zum Warenkorb
   * geleitet — die sichere Richtung.
   */
  var wahlBekannt = null; // '0' | '19' | '' | null = noch unbekannt

  function wahlLaden() {
    return fetch('/cart.js')
      .then(function (a) { return a.json(); })
      .then(function (c) {
        wahlBekannt = (c.attributes && c.attributes.iv_steuersatz) || '';
        /* Die Mindestmengen kosten einen zweiten Abruf — nur wenn ueberhaupt
         * etwas im Warenkorb liegt. */
        if (c.item_count) return moqWarenkorbPruefen().catch(function () { moqStand = null; });
        moqStand = [];
      })
      .catch(function () { /* bleibt null -> Waechter leitet zum Warenkorb */ });
  }

  function istKassenZiel(el) {
    if (!el || el.nodeType !== 1 || !el.getAttribute) return false;
    var h = el.getAttribute('href') || '';
    if (/\/checkout(\?|$|#)/.test(h)) return true;   // Standard-Kassenlink
    if (/\/cart\/c\//.test(h)) return true;          // Direktlink der Schublade
    if (el.matches && el.matches('.upcart-checkout-button, [name="checkout"]')) return true;
    return false;
  }

  var waechterSteht = false;
  var standZeit = 0;
  function kassenWaechter() {
    if (waechterSteht) return;
    if (document.getElementById('iv-vat-switcher')) return; // Warenkorbseite: eigene Logik
    waechterSteht = true;
    wahlLaden();
    document.addEventListener('click', function (e) {
      var pfad = e.composedPath ? e.composedPath() : [e.target];
      var treffer = false;
      for (var i = 0; i < pfad.length; i++) { if (istKassenZiel(pfad[i])) { treffer = true; break; } }
      if (!treffer) {
        /* Jeder andere Klick kann eine Menge geaendert haben — die Schublade
         * von UpCart meldet uns nichts. Deshalb wird der Stand nachgezogen,
         * gedrosselt auf einmal je 1,5 Sekunden. Adress- statt App-Logik:
         * das haelt auch nach einem Update der Schublade. */
        var jetzt = Date.now();
        if (jetzt - standZeit > 1500) { standZeit = jetzt; wahlLaden(); }
        return;
      }
      var moqOffen = moqVerstoesse(moqStand);
      if (moqOffen.length) {
        e.preventDefault();
        e.stopPropagation();
        try { sessionStorage.setItem(MOQ_SPEICHER, moqMeldung(moqOffen)); } catch (x) { /* egal */ }
        window.location.href = '/cart';
        return;
      }
      if (wahlBekannt === '0') return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/cart';
    }, true);
  }

  /* --- Die (i)-Erklaerungen: Overlay statt Aufklappen (19.09.2026) ------
   *
   * Bis dahin klappte der Text an Ort und Stelle auf, UNTER den Optionen. Auf
   * dem Telefon geschah damit nach dem Tippen scheinbar nichts: Der Text stand
   * ausserhalb des Bildausschnitts (Befund MS, 19.09.2026). Jetzt legt er sich
   * darueber und laesst sich wegklicken.
   *
   * DER TEXT BLEIBT, WO ER WAR. Das Fenster holt ihn aus demselben Block, der
   * ohne JavaScript aufklappt — eine Wahrheit, zwei Darstellungen. Wer den Satz
   * aendert, aendert ihn in Liquid und nirgends sonst.
   *
   * Ohne <dialog> bleibt es beim Aufklappen: unten gelesen ist besser als gar
   * nicht gelesen.
   */
  function infoAufklappen(b, ziel) {
    var offen = ziel.hasAttribute('hidden');
    if (offen) ziel.removeAttribute('hidden'); else ziel.setAttribute('hidden', '');
    b.setAttribute('aria-expanded', String(offen));
  }

  function infoBinden() {
    var fenster = document.getElementById('iv-vat-info');
    var kannDialog = Boolean(fenster) && typeof fenster.showModal === 'function';
    document.querySelectorAll('.iv-vat__info-btn:not([data-iv-bound])').forEach(function (b) {
      b.setAttribute('data-iv-bound', '1');
      b.addEventListener('click', function () {
        var ziel = document.getElementById(b.getAttribute('aria-controls'));
        if (!ziel) return;
        if (!kannDialog) { infoAufklappen(b, ziel); return; }
        var titel = fenster.querySelector('[data-iv-info-titel]');
        var text = fenster.querySelector('[data-iv-info-text]');
        if (!titel || !text) { infoAufklappen(b, ziel); return; }
        /* Die Ueberschrift ist die Option selbst — sie steht schon da und muss
         * nicht ein zweites Mal geschrieben werden. */
        var option = b.closest ? b.closest('.iv-vat-switcher__option') : null;
        var stark = option && option.querySelector('strong');
        if (stark) titel.textContent = stark.textContent.trim();
        text.innerHTML = ziel.innerHTML;
        fenster.showModal();
      });
    });
  }

  /* --- AUSLAND: erkennen, fuehren, im Overlay erklaeren -----------------
   *
   * Wer aus Oesterreich oder der Schweiz kommt, sah bis zum 18.09.2026 nichts
   * und brach im Checkout ab: 84 Sitzungen im Jahr erreichten ihn, 6 kamen
   * durch (Messung 18.09.2026). Dieser Abschnitt erkennt das Land, zeigt die
   * Karte und oeffnet auf Klick den Weg als OVERLAY (Vorgabe MS, 19.09.2026) —
   * keine eigene Seite, weil der Kunde mitten im Kauf steht und nicht
   * weggefuehrt werden soll.
   *
   * DAS LAND KOMMT VON SHOPIFY SELBST: /browsing_context_suggestions.json
   * beantwortet die Frage aus der IP — kein fremder Geo-Dienst, die IP geht an
   * niemanden weiter, also keine Einwilligungsfrage. Einmal je Sitzung, danach
   * aus sessionStorage. OFFEN bis zur Abnahme (Umsetzungsplan v2, Abschnitt 1):
   * ob die Antwort AT/CH hergibt, solange diese Laender in keinem Markt stehen.
   * Sagt sie nur DE, wird `landHolen` gegen die Proxy-Route getauscht — eine
   * Funktion, der Rest dieses Abschnitts bleibt.
   *
   * JEDER FEHLER IST STILL, und der Knopf bleibt trotzdem begehbar: Er ist ein
   * echter Link auf die Laenderseite; erst JavaScript macht ein Overlay daraus.
   * Kein Skript, kein Dialog, keine Section — der Weg fuehrt dann eben ueber
   * die Seite. Ein Knopf, der nichts tut, ist schlimmer als ein Seitenwechsel.
   *
   * Damit ein stiller Ausfall der Erkennung nicht als fehlende Nachfrage
   * durchgeht, wird jede Einblendung und jede Oeffnung in Clarity
   * gekennzeichnet; der Abgleich dieser Zahl gegen die Sitzungen aus
   * messung/laender.mjs ist die eigentliche Sicherung — nicht dieser Code.
   */
  var AUSLAND_LAENDER = ['AT', 'CH'];
  var AUSLAND_LAND_SPEICHER = 'ivLand';
  var AUSLAND_WEG_SPEICHER = 'ivAuslandWeg';
  var auslandLand;            // undefined = noch nicht gefragt, null = unbekannt
  var auslandLaeuft = null;   // die eine laufende Abfrage, nicht je Kasten eine

  function auslandSpeicher(schluessel, wert) {
    /* Privates Fenster und gesperrte Seitendaten werfen hier — beides ist kein
     * Fehler, sondern nur eine Sitzung ohne Gedaechtnis. */
    try {
      if (wert === undefined) return sessionStorage.getItem(schluessel);
      sessionStorage.setItem(schluessel, wert);
    } catch (e) { /* ohne Gedaechtnis weiter */ }
    return null;
  }

  function landHolen() {
    if (auslandLand !== undefined) return Promise.resolve(auslandLand);
    var gemerkt = auslandSpeicher(AUSLAND_LAND_SPEICHER);
    if (gemerkt) { auslandLand = gemerkt; return Promise.resolve(auslandLand); }
    if (auslandLaeuft) return auslandLaeuft;
    auslandLaeuft = fetch('/browsing_context_suggestions.json?country[enabled]=true', {
      headers: { Accept: 'application/json' }
    })
      .then(function (a) { return a.ok ? a.json() : null; })
      .then(function (j) {
        var erkannt = j && j.detected_values && j.detected_values.country;
        auslandLand = (erkannt && erkannt.handle) || null;
        if (auslandLand) auslandSpeicher(AUSLAND_LAND_SPEICHER, auslandLand);
        return auslandLand;
      })
      .catch(function () { auslandLand = null; return null; });
    return auslandLaeuft;
  }

  /* Gezaehlt wird in Clarity, weil es ohnehin im Theme liegt. Laeuft es wegen
   * der Einwilligung nicht, ist die Zahl eine Untergrenze — fuer den
   * Soll-Ist-Vergleich gegen die Sitzungen reicht das. */
  function auslandMerken(was, wert) {
    try { if (window.clarity) window.clarity('set', was, wert); } catch (e) { /* egal */ }
  }

  function auslandFuellen(kasten, land) {
    var k = land.toLowerCase();
    var titel = kasten.getAttribute('data-' + k + '-titel');
    var text = kasten.getAttribute('data-' + k + '-text');
    var knopf = kasten.getAttribute('data-' + k + '-knopf');
    var klein = kasten.getAttribute('data-' + k + '-klein');
    var ziel = kasten.getAttribute('data-' + k + '-ziel');
    /* Kein Text fuer dieses Land heisst: nichts zeigen. Ein halb gefuellter
     * Kasten waere schlimmer als keiner. */
    if (!titel || !text || !knopf || !klein || !ziel) return false;
    var eTitel = kasten.querySelector('[data-iv-ausland-titel]');
    var eText = kasten.querySelector('[data-iv-ausland-text]');
    var eZiel = kasten.querySelector('[data-iv-ausland-ziel]');
    var eKlein = kasten.querySelector('[data-iv-ausland-klein]');
    if (!eTitel || !eText || !eZiel || !eKlein) return false;
    eTitel.textContent = titel;
    eText.textContent = text;
    eZiel.textContent = knopf;
    eZiel.setAttribute('href', ziel);
    eKlein.textContent = klein;
    /* Die Fahne haengt am Behaelter, nicht an jedem Fahnenfeld: So gilt sie
     * zugleich fuer den vollen Kasten und fuer den Streifen. */
    kasten.setAttribute('data-land', land);
    return true;
  }

  /* Zugeklappt heisst NICHT weg (Vorgabe MS, 19.09.2026): Der Kasten schrumpft
   * auf eine Zeile, die ihn zurueckholt. Wer sich anders entscheidet, findet
   * den Weg wieder — ohne die Seite neu zu laden. */
  function auslandKlappen(kasten, zu) {
    var voll = kasten.querySelector('[data-iv-ausland-voll]');
    var streifen = kasten.querySelector('[data-iv-ausland-zurueck]');
    if (!voll || !streifen) return;
    if (zu) {
      voll.setAttribute('hidden', '');
      streifen.removeAttribute('hidden');
    } else {
      voll.removeAttribute('hidden');
      streifen.setAttribute('hidden', '');
    }
  }

  function auslandAlleKlappen(zu) {
    auslandSpeicher(AUSLAND_WEG_SPEICHER, zu ? '1' : '0');
    document.querySelectorAll('[data-iv-ausland]').forEach(function (k) {
      auslandKlappen(k, zu);
    });
  }

  /* ---- Der Dialog ------------------------------------------------------
   *
   * Geholt wird der Abschnitt `iv-ausland-dialog` erst beim Klick, Bauart wie
   * `iv-abholorte` und `iv-moq`. Zwei Gruende: Es sind zwei vollstaendige Wege
   * mit Formular, die 98 % der Besucher nie brauchen — und weil er im Augenblick
   * des Klicks entsteht, traegt das Formular den Warenkorb von JETZT. Deshalb
   * wird bei jedem Oeffnen frisch geholt und der alte Halter ersetzt: Ein
   * gemerkter Dialog zeigte den Warenkorb von vorhin, und das faellt niemandem
   * auf — die schlechteste Art von Fehler.
   */
  function auslandDialogHolen() {
    var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(wurzel + '?section_id=iv-ausland-dialog')
      .then(function (a) {
        if (!a.ok) throw new Error('HTTP ' + a.status);
        return a.text();
      })
      .then(function (html) {
        var neu = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-iv-ausland-dialoge]');
        if (!neu) throw new Error('Abschnitt iv-ausland-dialog fehlt im Theme');
        var alt = document.querySelector('[data-iv-ausland-dialoge]');
        if (alt && alt.parentNode) alt.parentNode.removeChild(alt);
        document.body.appendChild(neu);
        neu.querySelectorAll('[data-iv-ausland-formular]').forEach(auslandFormularBinden);
        return neu;
      });
  }

  function auslandDialogOeffnen(land, knopf) {
    return auslandDialogHolen().then(function (halter) {
      var dlg = halter.querySelector('[data-iv-dialog="' + land + '"]');
      if (!dlg || typeof dlg.showModal !== 'function') throw new Error('kein Dialog fuer ' + land);
      dlg.showModal();
      auslandMerken('ausland-dialog', land);
      return true;
    }).catch(function (e) {
      /* Der Link tut, was er ohnehin tun wuerde: auf die Laenderseite. */
      if (window.console) console.warn('inselvolt Auslandsdialog:', e);
      if (knopf && knopf.getAttribute('href')) window.location.href = knopf.getAttribute('href');
      return false;
    });
  }

  /* Das Formular ist Shopifys eigenes Kontaktformular. Abgeschickt wird es per
   * fetch, damit der Kunde im Dialog bleibt und nicht aus dem Kauf faellt.
   * Geht das schief, wird ganz normal abgeschickt — dann wechselt die Seite,
   * aber die Anfrage geht raus. */
  function auslandFormularBinden(formular) {
    formular.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; // dann der gewoehnliche Weg
      e.preventDefault();
      var knopf = formular.querySelector('[type="submit"]');
      var meldung = formular.querySelector('[data-iv-ausland-meldung]');
      var alt = knopf ? knopf.textContent : '';
      if (knopf) { knopf.disabled = true; knopf.textContent = 'Wird gesendet …'; }
      if (meldung) { meldung.textContent = ''; meldung.className = 'iv-dlg__meldung'; }
      fetch(formular.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(formular),
        headers: { Accept: 'text/html' }
      })
        .then(function (a) {
          if (!a.ok) throw new Error('HTTP ' + a.status);
          auslandMerken('ausland-anfrage', formular.getAttribute('data-iv-ausland-formular') || 'unbekannt');
          formular.reset();
          if (knopf) knopf.textContent = 'Gesendet';
          if (meldung) {
            meldung.className = 'iv-dlg__meldung iv-dlg__meldung--gut';
            meldung.textContent = 'Danke — wir melden uns in der Regel am selben Werktag.';
          }
        })
        .catch(function () {
          if (knopf) { knopf.disabled = false; knopf.textContent = alt; }
          if (meldung) {
            meldung.className = 'iv-dlg__meldung iv-dlg__meldung--schlecht';
            meldung.textContent = 'Das Senden hat nicht geklappt. Bitte schreiben Sie uns an support@inselvolt.de.';
          }
        });
    });
  }

  function auslandWeglegen(kasten) {
    var weg = kasten.querySelector('[data-iv-ausland-weg]');
    var zurueck = kasten.querySelector('[data-iv-ausland-zurueck]');
    if (weg) weg.addEventListener('click', function () { auslandAlleKlappen(true); });
    if (zurueck) zurueck.addEventListener('click', function () { auslandAlleKlappen(false); });
  }

  function auslandKnopfBinden(kasten, land) {
    var knopf = kasten.querySelector('[data-iv-ausland-ziel]');
    if (!knopf) return;
    knopf.addEventListener('click', function (e) {
      /* Neuer Reiter, Mittelklick, Speichern unter: nicht abfangen. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      auslandDialogOeffnen(land, knopf);
    });
  }

  function ausland() {
    var kaesten = document.querySelectorAll('[data-iv-ausland]:not([data-iv-bereit])');
    var option = document.getElementById('iv-vat-ausfuhr-option');
    if (!kaesten.length && !option) return;
    landHolen().then(function (land) {
      if (!land || AUSLAND_LAENDER.indexOf(land) < 0) return;
      /* Weggeklickt gilt fuer die Kaesten, nicht fuer die Steuerwahl: Wer den
       * Hinweis wegklickt, soll trotzdem die richtige Option im Warenkorb
       * finden. */
      var zugeklappt = auslandSpeicher(AUSLAND_WEG_SPEICHER) === '1';
      kaesten.forEach(function (kasten) {
        kasten.dataset.ivBereit = '1';
        if (!auslandFuellen(kasten, land)) return;
        auslandKlappen(kasten, zugeklappt);
        kasten.removeAttribute('hidden');
        auslandKnopfBinden(kasten, land);
        auslandWeglegen(kasten);
        /* Gezaehlt wird der gezeigte Hinweis, nicht der Streifen: Sonst
         * stuende in der Messung eine Einblendung, die niemand gelesen hat. */
        if (!zugeklappt) {
          auslandMerken('ausland', land + ':' + (kasten.getAttribute('data-iv-stelle') || 'unbekannt'));
        }
      });
      /* Die dritte Steueroption gibt es nur fuer die Schweiz: Sie traegt eine
       * eigene Erklaerung (Ausfuhr), und die trifft auf sonst niemanden zu. */
      if (land === 'CH' && option) option.removeAttribute('hidden');
    }).catch(function () { /* still: ohne Erkennung bleibt der Laden, wie er ist */ });
  }

  function start() { produktseite(); moqProduktseite(); warenkorb(); moqWarenkorb(); infoBinden(); kassenWaechter(); ausland(); }
  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState !== 'loading') start();
})();
